function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { memo } from "react";
import { Box, Card, CardContent, CardHeader } from "@mui/material";
var SectionBox = function(param) {
    var children = param.children, title = param.title, subtitle = param.subtitle, action = param.action, CardProps = param.CardProps;
    return /*#__PURE__*/ _jsx(Box, {
        mb: 2,
        children: /*#__PURE__*/ _jsxs(Card, _object_spread_props(_object_spread({}, CardProps), {
            children: [
                title || action || subtitle ? /*#__PURE__*/ _jsx(CardHeader, {
                    title: title,
                    titleTypographyProps: {
                        variant: "h5",
                        gutterBottom: true
                    },
                    subheader: subtitle,
                    action: action
                }) : undefined,
                /*#__PURE__*/ _jsx(CardContent, {
                    children: children
                })
            ]
        }))
    });
};
export default /*#__PURE__*/ memo(SectionBox);
